import {IAppModel, IProperties, IRootScope} from '../hpc';
import {ILocationService} from 'angular';


export class InfoService {

    private isIOSDevice() {
        const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
        return /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;
    }

    private getIOSVersion(): string | null {
        try {
            if (!this.isIOSDevice()) {
                return null;
            }
            const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
            const match = userAgent.match(/OS (\d+)_(\d+)/);
            if (!match) {
                return null;
            }
            // Return Major.Minor format (e.g., "17.2")
            return `${match[1]}.${match[2]}`;
        } catch (e) {
            // Fail silently, no errors for version parsing
            return null;
        }
    }

    private isIOSUpdateDetected(id: string): boolean {
        try {
            if (!this.isIOSDevice()) {
                return false;
            }

            if (!this.$localStorage.messageConfirmations) {
                return false;
            }

            const confirmation = this.$localStorage.messageConfirmations[id];
            if (!confirmation) {
                return false;
            }

            // Old confirmation (boolean) exists for iOS device
            if (confirmation === true) {
                return true;
            }

            // New confirmation with version exists, check if version changed
            if (typeof confirmation === 'object' && confirmation.iosVersion) {
                const currentVersion = this.getIOSVersion();
                if (currentVersion && confirmation.iosVersion !== currentVersion) {
                    return true;
                }
            }

            return false;
        } catch (e) {
            return false;
        }
    }

    public static $inject = ['$rootScope','$localStorage','$sessionStorage', 'properties', '$location'];

    constructor(
        private $rs: IRootScope,
        private $localStorage: any,
        private appModel: IAppModel,
        private properties: IProperties,
        private $location: ILocationService,
    ) {

    }
    
    public displayInitMessages(){
        console.log('displayInitMessages');
        console.log("UserAgent:  " + navigator.userAgent);
        let isMobile = this.$rs.viewMode == 'mobile';

        // Check if message should be displayed
        const shouldDisplay = (isMobile && this.isIOSDevice() && !this.isConfirmed('livevoicemail') && !this.isSuppressed('livevoicemail'))
            || (!isMobile && !this.isConfirmed('livevoicemail') && !this.isSuppressed('livevoicemail'));

        if (shouldDisplay) {
            // Determine which message to show
            let messageKey = "MESSAGE_LIVE_VOICEMAIL";

            // For iOS: check if this is due to an update
            if (this.isIOSUpdateDetected('livevoicemail')) {
                messageKey = "MESSAGE_LIVE_VOICEMAIL_IOS_UPDATE";
            }

            this.$rs.errormessage = {message: messageKey, type: 'warning', id: 'livevoicemail'};
        }
    }

    public confirmErrorMessage = function (id) {
        if(!id){
            return;
        }
        this.$rs.errormessage = null;
        if (this.$localStorage.messageConfirmations === undefined) {
            this.$localStorage.messageConfirmations = {};
        }

        // For iOS devices, store version information
        const iosVersion = this.getIOSVersion();
        if (iosVersion) {
            this.$localStorage.messageConfirmations[id] = {
                confirmed: true,
                iosVersion: iosVersion
            };
        } else {
            // For non-iOS devices, keep simple boolean
            this.$localStorage.messageConfirmations[id] = true;
        }
    }

    public isConfirmed = function (id) {
        if (id == null) {
            return true;
        }

        if (this.$localStorage.messageConfirmations === undefined) {
            return false;
        }

        const confirmation = this.$localStorage.messageConfirmations[id];

        // Not confirmed at all
        if (!confirmation) {
            return false;
        }

        // Old structure: boolean true
        if (confirmation === true) {
            // For iOS: treat old confirmations as outdated (trigger update message)
            const currentVersion = this.getIOSVersion();
            if (currentVersion) {
                return false;
            }
            // For non-iOS: keep working as before
            return true;
        }

        // New structure: object with iosVersion
        if (typeof confirmation === 'object' && confirmation.iosVersion) {
            try {
                const currentVersion = this.getIOSVersion();
                if (!currentVersion) {
                    // Shouldn't happen, but fail gracefully
                    return true;
                }
                // Check if iOS version has changed
                return confirmation.iosVersion === currentVersion;
            } catch (e) {
                // On error, treat as confirmed to avoid spam
                return true;
            }
        }

        // Fallback: treat as confirmed
        return true;
    }

    public isSuppressed = function (id) {
        return this.appModel.mandator.mandatorAttributes.suppressMessages && this.appModel.mandator.mandatorAttributes.suppressMessages.indexOf(id) > -1;
    }



}